/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateContainerInfoInput = {
    clientMutationId?: string | null;
    slug: string;
    bookingNumber?: string | null;
    containerSize?: string | null;
    pickupReference?: string | null;
    turninReference?: string | null;
    thcPaidDate?: string | null;
    pickupLocationSlug?: string | null;
    turninLocationSlug?: string | null;
    latestPickupDate?: string | null;
    latestTurninDate?: string | null;
    terminalDate?: string | null;
    pickupDate?: string | null;
    warehouseInDate?: string | null;
    warehouseOutDate?: string | null;
    released?: boolean | null;
    terminalStop?: boolean | null;
    hazardous?: boolean | null;
    pickupComment?: string | null;
};
export type ContainerInfoCardEditMutationVariables = {
    input: infoUpdateContainerInfoInput;
};
export type ContainerInfoCardEditMutationResponse = {
    readonly infoUpdateContainerInfo: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerInfoCardEditMutation = {
    readonly response: ContainerInfoCardEditMutationResponse;
    readonly variables: ContainerInfoCardEditMutationVariables;
};



/*
mutation ContainerInfoCardEditMutation(
  $input: infoUpdateContainerInfoInput!
) {
  infoUpdateContainerInfo(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUpdateContainerInfoPayload",
    "kind": "LinkedField",
    "name": "infoUpdateContainerInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerInfoCardEditMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerInfoCardEditMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "782aa1b904a720b379e2e9fd3705cc9b",
    "id": null,
    "metadata": {},
    "name": "ContainerInfoCardEditMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerInfoCardEditMutation(\n  $input: infoUpdateContainerInfoInput!\n) {\n  infoUpdateContainerInfo(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '3593f9211ae12e3c22c574044a8e8e5c';
export default node;
